// this is an issue from their docs
// @ts-ignore
import type { InitOptions } from 'i18next'
import { accessControlTranslations } from './accessControl'
import { bodyMapsTranslations } from './bodyMaps'
import { carePlansTranslations } from './carePlans'
import { cernerTranslations } from './cerner'
import { consentTranslations } from './consent'
import { cqiTranslations } from './cqi'
import { dacTranslations } from './deviceAccessControl'
import { deviceRecordTranslations } from './deviceRecords'
import { emarV2Translations } from './emarV2'
import { enTranslations } from './enTranslations'
import { familyPortalSettingsTranslations } from './familyPortalSettings'
import { generalTranslations } from './general'
import { goalReportsTranslations } from './goalReports'
import { goalsTranslations } from './goals'
import { gpConnectTranslations } from './gpConnect'
import { homeChangedBlockingModalTranslations } from './homeChangedBlockingModal'
import { homeSettingsTranslations } from './homeSettings'
import { homeSwitchTranslations } from './homeSwitch'
import { incidentReportsTranslations } from './incidentReports'
import { monitoringReportTranslations } from './monitoringReports'
import { noticeboardTranslations } from './noticeboard'
import { painchekTranslations } from './painchek'
import { pbsTranslations } from './pbs'
import { privacyOfficersTranslations } from './privacyOfficers'
import { procedureTranslations } from './procedures'
import { referralTranslations } from './referrals'
import { reportingTranslations } from './reporting'
import { reportsTranslations } from './reports'
import { residentHealthRecordsTranslations } from './residentHealthRecords'
import { riskAssessmentFormTranslations } from './riskAssessmentForm'
import { riskAssessmentReportTranslations } from './riskAssessmentReports'
import { riskAssessmentsTranslations } from './riskAssessments'
import { selfServeTranslations } from './selfServe'
import { serviceRecordTranslations } from './serviceRecords'
import { serviceUserProfileTranslations } from './serviceUserProfile'
import { shiftPasswordsTranslations } from './shiftPasswords'
import { teamTranslations } from './team'
import { toDosTranslations } from './toDos'
import { transferRecordTranslations } from './transferRecords'

export const NAMESPACE = {
  GOALS: 'goals',
  TODOS: 'toDos',
  RESOURCES: 'resources',
  PAINCHECK: 'painchek',
  GENERAL: 'general',
  REPORTS: 'reports',
  TEAM: 'team',
  RISK_ASSESSMENT_REPORT: 'riskAssessmentReport',
  RISK_ASSESSMENTS: 'riskAssessments',
  RISK_ASSESSMENTS_FORM: 'riskAssessmentForm',
  MONITORING_REPORTS: 'monitoringReport',
  INCIDENT_REPORTS: 'incidentReport',
  GOAL_REPORTS: 'goalReport',
  DEVICE_ACCESS_CONTROL: 'deviceAccessControl',
  SELF_SERVE: 'selfServe',
  NOTICEBOARD: 'noticeboard',
  SERVICE_USER_PROFILE: 'serviceUserProfile',
  PRIVACY_OFFICERS: 'privacyOfficers',
  REPORTING: 'reporting',
  GP_CONNECT: 'GPConnect',
  CQI: 'CQI',
  PBS: 'PBS',
  CERNER: 'CERNER',
  CARE_PLANS: 'carePlans',
  ACCESS_CONTROL: 'accessControl',
  BODY_MAPS: 'bodyMaps',
  EMAR_V2: 'emarMedicationStockV2',
  RESIDENT_HEALTH_RECORDS: 'residentHealthRecords',
  CONSENT: 'consent',
  PROCEDURES: 'procedures',
  REFERRALS: 'referrals',
  SERVICE_RECORDS: 'serviceRecords',
  TRANSFER_RECORDS: 'transferRecords',
  DEVICE_RECORDS: 'deviceRecords',
  FAMILY_PORTAL_SETTINGS: 'familyPortalSettings',
  HOME_CHANGED_BLOCKING_MODAL: 'homeChangedBlockingModal',
  HOME_SWITCH: 'homeSwitch',
  HOME_SETTINGS: 'homeSettings',
  SHIFT_PASSWORDS: 'shiftPasswords'
}

export const resources: InitOptions['resources'] = {
  en: {
    [NAMESPACE.GOALS]: goalsTranslations,
    [NAMESPACE.TODOS]: toDosTranslations,
    [NAMESPACE.PAINCHECK]: painchekTranslations,
    [NAMESPACE.RESOURCES]: enTranslations,
    [NAMESPACE.GENERAL]: generalTranslations,
    [NAMESPACE.REPORTS]: reportsTranslations,
    [NAMESPACE.TEAM]: teamTranslations,
    [NAMESPACE.RISK_ASSESSMENT_REPORT]: riskAssessmentReportTranslations,
    [NAMESPACE.RISK_ASSESSMENTS]: riskAssessmentsTranslations,
    [NAMESPACE.RISK_ASSESSMENTS_FORM]: riskAssessmentFormTranslations,
    [NAMESPACE.MONITORING_REPORTS]: monitoringReportTranslations,
    [NAMESPACE.INCIDENT_REPORTS]: incidentReportsTranslations,
    [NAMESPACE.GOAL_REPORTS]: goalReportsTranslations,
    [NAMESPACE.DEVICE_ACCESS_CONTROL]: dacTranslations,
    [NAMESPACE.NOTICEBOARD]: noticeboardTranslations,
    [NAMESPACE.SELF_SERVE]: selfServeTranslations,
    [NAMESPACE.SERVICE_USER_PROFILE]: serviceUserProfileTranslations,
    [NAMESPACE.PRIVACY_OFFICERS]: privacyOfficersTranslations,
    [NAMESPACE.REPORTING]: reportingTranslations,
    [NAMESPACE.GP_CONNECT]: gpConnectTranslations,
    [NAMESPACE.CQI]: cqiTranslations,
    [NAMESPACE.PBS]: pbsTranslations,
    [NAMESPACE.CERNER]: cernerTranslations,
    [NAMESPACE.CARE_PLANS]: carePlansTranslations,
    [NAMESPACE.ACCESS_CONTROL]: accessControlTranslations,
    [NAMESPACE.BODY_MAPS]: bodyMapsTranslations,
    [NAMESPACE.EMAR_V2]: emarV2Translations,
    [NAMESPACE.RESIDENT_HEALTH_RECORDS]: residentHealthRecordsTranslations,
    [NAMESPACE.CONSENT]: consentTranslations,
    [NAMESPACE.PROCEDURES]: procedureTranslations,
    [NAMESPACE.REFERRALS]: referralTranslations,
    [NAMESPACE.SERVICE_RECORDS]: serviceRecordTranslations,
    [NAMESPACE.TRANSFER_RECORDS]: transferRecordTranslations,
    [NAMESPACE.DEVICE_RECORDS]: deviceRecordTranslations,
    [NAMESPACE.FAMILY_PORTAL_SETTINGS]: familyPortalSettingsTranslations,
    [NAMESPACE.HOME_CHANGED_BLOCKING_MODAL]:
      homeChangedBlockingModalTranslations,
    [NAMESPACE.HOME_SWITCH]: homeSwitchTranslations,
    [NAMESPACE.HOME_SETTINGS]: homeSettingsTranslations,
    [NAMESPACE.SHIFT_PASSWORDS]: shiftPasswordsTranslations
  }
}
